import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PublicLeadGen = () => {
  const { username } = useParams();

  useEffect(() => {
    // Redirect to the backend-served HTML page
    // IMPORTANT: Use window.location.origin to stay on the same domain (production or preview)
    // This ensures homefixer360.com stays on homefixer360.com, not an old preview URL
    const baseUrl = window.location.origin;
    window.location.href = `${baseUrl}/api/leadgen/page/${username}`;
  }, [username]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Loading landing page...</p>
      </div>
    </div>
  );
};

export default PublicLeadGen;
